const BOOK_HEIGHT = 500;
const SEMI_MINOR_AXIS = 50;

export { BOOK_HEIGHT, SEMI_MINOR_AXIS };
